import { PLAYER_DEBUG_KEY } from '../constants/debugKey';

const playerBadgeStyles =
  'font-weight: bold; background-color: #3BB143; color: #FFFFFF; padding: 2px 8px; border-radius: 4px;';

export const playerLogger = ({ location, message }: { location: string; message: string }) => {
  if (typeof window !== 'undefined' && !!window.localStorage && !!window.localStorage[PLAYER_DEBUG_KEY]) {
    console.info('%cPlayer', playerBadgeStyles, `${location}: ${message}`);
  }
};
